export const utilities = {
  getDateFromTimeStamp: (date) => {
    const fullDate = new Date(date);
    return isNaN(fullDate.getTime()) ? "" : fullDate.toLocaleDateString();
  },

  showToast: (toastText, isError, timeout = 3000) => {
    const x = document.getElementById("snackbar");
    
    if (typeof toastText === "string" && toastText.includes("no_account_error")) {
      toastText = "Session expired, please relogin to continue.";
    }

    if (x) {
      x.innerHTML = utilities.replaceAll(toastText, "\n", "<br/>");
      x.classList.remove("show", "red");
      x.classList.add("show");
      if (isError) x.classList.add("red");

      setTimeout(() => {
        x.classList.remove("show", "red");
      }, timeout);
    }
  },

  isEmptyOrNull: (str) => {
    return str == null || str.toString().trim() === "";
  },

  replaceAll: (string, find, replaceStr) => {
    if (typeof string !== "string") return "";
    
    const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return string.replace(new RegExp(escapeRegExp(find), "g"), replaceStr);
  }
};
